import React, { useContext } from 'react';
import classnames from 'classnames';
import { CardsContext } from '../../CardsContext';
import './PlayList.scss';
import AppLink from '../../../../components/AppLink';

export function PlayList({
  activeId,
  className,
  list,
  redirectionClassTitle,
  ...props
}) {
  const { routes } = useContext(CardsContext);

  const sendLinkClickToAnalytics = (post_name, title) => {
    // actid=25
    window.analytics?.track("object:click", {
      "object": "class",
      "parent_object_title": redirectionClassTitle,
      "title": title,
      "url": `${routes.home}${post_name}/`
    });
  };

  return (
    <ul className={classnames('PlayList', className)} {...props}>
      {list.map(({ id, post_name, title, duration, date }) => (
        <li className={classnames('PlayList__item', {'PlayList__item-current': activeId === id})} key={id}>
          <div className="PlayList__item-icon">
            {activeId === id ? (
              <i className="fa fa-play-circle" />
            ) : (
              <i className="fa fa-play-circle-o" />
            )}
          </div>
          <div className="PlayList__item-content">
            <AppLink
              to={`${routes.home}${post_name}/`}
              className="PlayList__item-link"
              onClick={() => sendLinkClickToAnalytics(post_name, title)}
            >
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </AppLink>
            <div className="PlayList__item-meta">
              {duration}
              {date && (
                <>
                  <span> · </span>
                  {date}
                </>
              )}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
